(function () {
  function getStep(track) {
    const card = track.querySelector('.ted-parent-testimonials__card');
    if (!card) return 320;
    const style = getComputedStyle(card);
    const margin = parseFloat(style.marginRight) || 0;
    return card.offsetWidth + margin;
  }

  function isRtl(marquee) {
    return marquee.hasAttribute('xo-rtl') && marquee.getAttribute('xo-rtl') !== 'false';
  }

  function initTrack(track) {
    const scrollLayer = track.querySelector('[data-ted-testimonials-scroll]');
    const marquee = track.querySelector('xo-marquee');
    const prevBtn = track.querySelector('[data-ted-testimonials-prev]');
    const nextBtn = track.querySelector('[data-ted-testimonials-next]');

    if (!scrollLayer || !marquee || !prevBtn || !nextBtn) return;

    let offset = 0;

    const applyOffset = () => {
      scrollLayer.style.transform = `translate3d(${offset}px, 0, 0)`;
    };

    const scroll = (direction) => {
      const step = getStep(track) * (isRtl(marquee) ? -direction : direction);
      offset -= step;
      applyOffset();
    };

    prevBtn.addEventListener('click', (event) => {
      event.preventDefault();
      scroll(-1);
    });

    nextBtn.addEventListener('click', (event) => {
      event.preventDefault();
      scroll(1);
    });
  }

  function init() {
    document.querySelectorAll('[data-ted-testimonials-track]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
